var map = {
	"./brown_1-6.png": "./src/assets/brown_1-6.png",
	"./brown_2-6.png": "./src/assets/brown_2-6.png",
	"./brown_3-6.png": "./src/assets/brown_3-6.png",
	"./brown_4-6.png": "./src/assets/brown_4-6.png",
	"./brown_5-6.png": "./src/assets/brown_5-6.png",
	"./brown_6-6.png": "./src/assets/brown_6-6.png",
	"./green_1-6.png": "./src/assets/green_1-6.png",
	"./green_2-6.png": "./src/assets/green_2-6.png",
	"./green_3-6.png": "./src/assets/green_3-6.png",
	"./green_4-6.png": "./src/assets/green_4-6.png",
	"./green_5-6.png": "./src/assets/green_5-6.png",
	"./green_6-6.png": "./src/assets/green_6-6.png",
	"./grey_1-6.png": "./src/assets/grey_1-6.png",
	"./grey_2-6.png": "./src/assets/grey_2-6.png",
	"./grey_3-6.png": "./src/assets/grey_3-6.png",
	"./grey_4-6.png": "./src/assets/grey_4-6.png",
	"./grey_5-6.png": "./src/assets/grey_5-6.png",
	"./grey_6-6.png": "./src/assets/grey_6-6.png",
	"./red_1-6.png": "./src/assets/red_1-6.png",
	"./red_2-6.png": "./src/assets/red_2-6.png",
	"./red_3-6.png": "./src/assets/red_3-6.png",
	"./red_4-6.png": "./src/assets/red_4-6.png",
	"./red_5-6.png": "./src/assets/red_5-6.png",
	"./red_6-6.png": "./src/assets/red_6-6.png",
	"./yellow_1-6.png": "./src/assets/yellow_1-6.png",
	"./yellow_2-6.png": "./src/assets/yellow_2-6.png",
	"./yellow_3-6.png": "./src/assets/yellow_3-6.png",
	"./yellow_4-6.png": "./src/assets/yellow_4-6.png",
	"./yellow_5-6.png": "./src/assets/yellow_5-6.png",
	"./yellow_6-6.png": "./src/assets/yellow_6-6.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/.*_.*\\-6\\.png$";